export const SET_APP_TIMEZONE = 'SET_APP_TIMEZONE';
export const SET_APP_LOADING = 'SET_APP_LOADING';
export const SET_APP_LOADING_SAMPLES = 'SET_APP_LOADING_SAMPLES';
export const SET_APP_ERROR = 'SET_APP_ERROR';
export const SET_APP_CONTAINER_WIDTH = 'SET_APP_CONTAINER_WIDTH';

export const SET_SITE = 'SET_SITE';
export const SET_LOGGERS = 'SET_LOGGERS';
export const SET_SENSORS = 'SET_SENSORS';

export const SET_QUERY_PARAMS = 'SET_QUERY_PARAMS';
export const UPDATE_QUERY_PARAMS = 'UPDATE_QUERY_PARAMS';
export const SHIFT_QUERY_PARAMS = 'SHIFT_QUERY_PARAMS';
export const SET_QUERY_AGGREGATION_LEVEL = 'SET_QUERY_AGGREGATION_LEVEL';
export const QUERY_PARAMS_ZOOM_OUT = 'QUERY_PARAMS_ZOOM_OUT';
export const QUERY_PARAMS_SHIFT_LEFT = 'QUERY_PARAMS_SHIFT_LEFT';
export const QUERY_PARAMS_SHIFT_RIGHT = 'QUERY_PARAMS_SHIFT_RIGHT';

export const SET_GROUPING_FILTER = 'SET_GROUPING_FILTER';
export const SET_GROUPING_MODE = 'SET_GROUPING_MODE';
export const SET_GROUPING_CATEGORY = 'SET_GROUPING_CATEGORY';
export const GROUPING_MODE_OFF = 'GROUPING_MODE_OFF';
export const GROUPING_MODE_GROUP = 'GROUPING_MODE_GROUP';
export const GROUPING_MODE_SUM = 'GROUPING_MODE_SUM';
export const SET_GROUPING_FILTER_RELATIONS = 'SET_GROUPING_FILTER_RELATIONS';

export const GROUPING_CATEGORY_AREA = 'GROUPING_CATEGORY_AREA';
export const GROUPING_CATEGORY_EQUIPMENT = 'GROUPING_CATEGORY_EQUIPMENT';
export const GROUPING_CATEGORY_TYPE = 'GROUPING_CATEGORY_TYPE';

export const GROUPING_FILTER_EQUIPMENT_GROUP =
  'GROUPING_FILTER_EQUIPMENT_GROUP';
export const GROUPING_FILTER_EQUIPMENT_TYPE = 'GROUPING_FILTER_EQUIPMENT_TYPE';
export const GROUPING_FILTER_EQUIPMENT_DESCRIPTION =
  'GROUPING_FILTER_EQUIPMENT_DESCRIPTION';
export const GROUPING_FILTER_AREA_FUNCTIONAL =
  'GROUPING_FILTER_AREA_FUNCTIONAL';
export const GROUPING_FILTER_AREA_ROOM = 'GROUPING_FILTER_AREA_ROOM';
export const GROUPING_FILTER_TYPE = 'GROUPING_FILTER_TYPE';

export const GROUPING_FILTER_TOPOLOGY_NONE = 'GROUPING_FILTER_TOPOLOGY_NONE';
export const GROUPING_FILTER_TOPOLOGY_BUILDING =
  'GROUPING_FILTER_TOPOLOGY_BUILDING';
export const GROUPING_FILTER_TOPOLOGY_FLOOR = 'GROUPING_FILTER_TOPOLOGY_FLOOR';

export const GROUPING_EQUIPMENT_TYPE = 'GROUPING_EQUIPMENT_TYPE';
export const GROUPING_EQUIPMENT_GROUP = 'GROUPING_EQUIPMENT_GROUP';
export const GROUPING_EQUIPMENT_DESCRIPTION = 'GROUPING_EQUIPMENT_DESCRIPTION';

export const GROUPING_AREA_ROOM = 'GROUPING_AREA_ROOM';

export const SET_CHART_TYPE = 'SET_CHART_TYPE';
export const SET_CHART_ENERGY_TYPE = 'SET_CHART_ENERGY_TYPE';
export const SET_CHART_ZOOM_FETCH = 'SET_CHART_ZOOM_FETCH';
export const SET_CHART_CONNECT_NULLS = 'SET_CHART_CONNECT_NULLS';

export const SANKEY_COLUMN_FILTER = 'SANKEY_COLUMN_FILTER';
export const SET_SANKEY_OPTIONS_NAMES = 'SET_SANKEY_OPTIONS_NAMES';
export const SET_SANKEY_OPTIONS_COSTS = 'SET_SANKEY_OPTIONS_COSTS';
export const SET_SANKEY_OPTIONS_VALUES = 'SET_SANKEY_OPTIONS_VALUES';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js